module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-01.12fec551.jpg";